import { Injectable } from "@angular/core";
import { Parada } from "@tivic-team/manager-ts/dist/mob/entities/parada/parada.entity";
import { ParadaController } from "app/controllers/mob/parada.controller";
import { ParadaDTO } from "app/model/dtos/mob/parada.dto";
import { LoaderService } from "../loader.service";
import { TaxiNumeroOrdemSearch } from "./taxi-numero-ordem.search";


@Injectable({
    providedIn: "root",
})


export class TaxiNumeroOrdemServices {
    constructor(
        private _paradaController: ParadaController,
        private _loaderService: LoaderService
    ){}

    async find(taxiNumeroOrdemSearch: TaxiNumeroOrdemSearch): Promise<Array<Parada>>{
        this._loaderService.show()
        try{
            return await this._paradaController.findTaxis((taxiNumeroOrdemSearch && taxiNumeroOrdemSearch.getFilters()) || null)
            .finally(() => this._loaderService.hide());
        }catch(error){
            this._loaderService.hide();
            return [];
        }
    }

    async save(paradaDTO: ParadaDTO): Promise<ParadaDTO> {
        console.log('Loading Taxi Numero Ordem Service...');
        this._loaderService.show();
        if(paradaDTO.parada.cdParada && paradaDTO.parada.cdParada > 0){
            console.log('Update...');
            return this._paradaController.update(paradaDTO).finally(() => this._loaderService.hide());
        }else {
            console.log('Create...');
            return this._paradaController.create(paradaDTO).finally(() => this._loaderService.hide());
        }
    }

    async get(cdParada: number): Promise<ParadaDTO>{
        this._loaderService.show();
        return this._paradaController.getTaxis(cdParada).finally(() => this._loaderService.hide());
    }
}